/* eslint-disable max-lines-per-function */
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { PopoverContent } from '@/components/ui/popover';
import { CheckboxPlaceholder } from '@/domain/arbeitszeiten/components/CheckboxPlaceholder/CheckboxPlaceholder';
import { getColorByOption } from '@/domain/arbeitszeiten/components/Comboboxen/ArbeitsbereichCombobox/getColorByOption';
import { Markierung } from '@/domain/arbeitszeiten/components/Markierung';
import { Arbeitsbereich } from '@/domain/arbeitszeiten/entities';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

export function ArbeitsbereichComboboxPopoverContent({
  selectedArbeitsbereiche,
  arbeitsbereiche,
  setSelectedArbeitsbereiche,
  onOpenChange,
  onSelect,
  minimunSelect,
  multiSelect,
}: {
  selectedArbeitsbereiche: Arbeitsbereich[];
  arbeitsbereiche: Arbeitsbereich[];
  setSelectedArbeitsbereiche: Dispatch<SetStateAction<Arbeitsbereich[]>>;
  onOpenChange?: (open: boolean) => void;
  onSelect: (arbeitsbereiche: Arbeitsbereich[]) => void;
  minimunSelect?: number;
  multiSelect?: boolean;
}) {
  const { t } = useTranslation();

  function handleSelect(currentValue: string) {
    const selectedIds = selectedArbeitsbereiche.map(
      (arbeitsbereich) => arbeitsbereich.id,
    );

    const id = currentValue.split('% %')[1];
    if (selectedIds.includes(id)) {
      if (selectedArbeitsbereiche.length <= minimunSelect) {
        return;
      }
      setSelectedArbeitsbereiche((selectedArbeitsbereiche) => {
        const updatedArbeitsbereiche = selectedArbeitsbereiche.filter(
          (selectedArbeitsbereich) => selectedArbeitsbereich.id !== id,
        );
        onSelect(updatedArbeitsbereiche);
        if (onOpenChange) {
          onOpenChange(false);
        }
        return updatedArbeitsbereiche;
      });
    } else {
      setSelectedArbeitsbereiche((selectedArbeitsbereiche) => {
        const arbeitsbereich = arbeitsbereiche.find(
          (arbeitsbereich) => arbeitsbereich.id === id,
        );
        const updatedArbeitsbereiche = multiSelect
          ? [...selectedArbeitsbereiche, arbeitsbereich]
          : [arbeitsbereich];
        onSelect(updatedArbeitsbereiche);
        if (onOpenChange) {
          onOpenChange(false);
        }
        return updatedArbeitsbereiche;
      });
    }
  }

  return (
    <PopoverContent className="w-[280px] p-0">
      <Command
        filter={(value, search) => {
          if (
            value
              .split('% %')[0]
              .toLocaleLowerCase()
              .includes(search.toLocaleLowerCase())
          ) {
            return 1;
          }
          return 0;
        }}>
        <CommandInput
          placeholder={t(
            'domain.arbeitszeiten.uebersicht.arbeitsbereichfilter.search',
          )}
          className="h-9"
        />
        <CommandList>
          <CommandEmpty className="text-center text-neutrals-N700 pb-4 text-sm">
            {t('domain.arbeitszeiten.uebersicht.arbeitsbereichfilter.notFound')}
          </CommandEmpty>
          <CommandGroup>
            {arbeitsbereiche.map((arbeitsbereich) => {
              const isSelected = selectedArbeitsbereiche.find(
                (a) => a.id === arbeitsbereich.id,
              );

              return (
                <CommandItem
                  key={arbeitsbereich.id}
                  //Wird benötigt um eindeutige Arbeitsbereiche zu haben, die den gleichen namen haben.
                  //Wird in der Filter funktion ausgewertet
                  //Und ja ich schäme mich dafüer aber andere Lösungen finde ich nicht :'(
                  value={`${arbeitsbereich.name}% %${arbeitsbereich.id}`}
                  onSelect={(currentValue) => {
                    handleSelect(currentValue);
                  }}>
                  <div className="flex justify-between items-center w-full font-normal">
                    <div className="flex gap-2 items-center truncate max-w-36">
                      <Markierung
                        color={getColorByOption(
                          arbeitsbereich.id,
                          arbeitsbereiche,
                        )}
                      />
                      <span className="truncate">{arbeitsbereich.name}</span>
                    </div>
                    <CheckboxPlaceholder checked={isSelected !== undefined} />
                  </div>
                </CommandItem>
              );
            })}
          </CommandGroup>
        </CommandList>
      </Command>
    </PopoverContent>
  );
}
